var AuthFormForgotpassword = ( function($) {

    var AuthFormForgotpassword = function(options) {
        this.init(options);
    };

    var Self = AuthFormForgotpassword;
    Self.className = 'AuthFormForgotpassword';
    var Parent = ActionformAbstract;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;
        Parent.prototype.init.call(that, options);
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            form: '.js-form-forgotpassword',
            next_action: '.js-form-forgotpassword-confirm', // only for reset password by phone (sends confirmation code instead of link)
            previous_action: '.js-form-login',
            success_sent_to: '.js-sent-to',

            next_action_sent_to: '.js-sent-to',
            next_action_login_input: '.js-login',
            next_action_code_request_timelimit: '.js-request-code-timelimit',
        };

        that.data_keys = {
            next_action_next_code_time_limit: 'time-limit',
        };

        // to save data in the local storage, when not in modal mode (next action is separate page e.g.)
        that.next_action_data_key_prefix = 'avia/auth-reset-password-by-code';

        that.url = $.sa.build_url('auth/reset-password');
        that.method = 'POST';

        that.has_success_screen = true; // but only if reset password by email (when sends link)

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.initDomElements = function () {
        var that = this;

        Parent.prototype.initDomElements.call(that);

        that.$success_sent_to = that.$success_wrapper.find(that.selectors.success_sent_to);
    };

    Self.prototype.initNextAction = function ($action) {
        var that = this;

        Parent.prototype.initNextAction.call(that, $action);

        that.$next_action_sent_to = that.$next_action.find(that.selectors.next_action_sent_to);
        that.$next_action_login_input = that.$next_action.find(that.selectors.next_action_login_input);
        that.$next_action_code_request_timelimit = that.$next_action.find(that.selectors.next_action_code_request_timelimit);
    };

    Self.prototype.onDoneSubmitHandleSuccess = function (response) {
        var that = this,
            handlers = that.onDoneSubmitHandlers();

        if (that.isRedirectResponse(response)) {
            var url = that.getRedirectUrl(response);
            return (handlers.redirect && handlers.redirect(url));
        }
        else {
            // show next screen as in modal mode by default
            return (handlers.goToNext && handlers.goToNext(response));
        }
    };

    Self.prototype.onDoneSubmitHandlers = function () {
        var that = this,
            handlers_default = Parent.prototype.onDoneSubmitHandlers.call(that),
            handlers_custom = Object.assign({}, handlers_default);

        handlers_custom.goToNext = function (response) {
            var data = (response && response.data) || {},
                login_type = data.type || '';

            if (login_type === 'email') {
                that.beforeMoveToSuccess(response);
                that.toSuccess();
            } else if (login_type === 'phone') {
                that.beforeMoveToNextAction(response);
                that.toNextAction();
            } else {
                handlers_default.errors([{_alert: that.getLocalePhrase('error_occurred'), code: 3010}], response);
            }

            return true;
        };

        return handlers_custom;
    };

    Self.prototype.beforeMoveToSuccess = function (response) {
        var that = this,
            data = (response && response.data) || {},
            sent_to = data.sent_to || '';

        that.setSuccessSentToText(sent_to);
    };

    Self.prototype.beforeMoveToNextAction = function (response) {
        var that = this,
            data = (response && response.data) || {},
            is_redirect = that.isRedirectResponse(response);

        // set `sent_to`, `login` and `next_code_time` values
        // (in modal mode it should be made after next action was shown)
        that.__saveNextActionData(data, is_redirect);
    };

    Self.prototype.showErrors = function (errors) {
        errors = errors || [];

        var that = this,
            // "out of limit code requests" error
            request_limit_error_index = errors.findIndex(er => er.code == 9102), // if someday we won't need to display that error, we could delete that error from the `errors` by index
            blocked_error_index = errors.findIndex(er => er.code == 9100);

        if (-1 !== request_limit_error_index || -1 !== blocked_error_index) {
            that.toggleSubmitButtonAvailability(false);
            // if someday we won't need to display that error, uncomment next line, and remove previous line
            // errors.splice(request_limit_error_index, 1);
        }
        Parent.prototype.showErrors.call(that, errors);
    };

    Self.prototype.__saveNextActionData = function (data, is_redirect) {
        var that = this;

        if (!is_redirect) {
            that.__saveNextActionDataModalMode(data);
        }
        else {
            that.__saveNextActionDataNotModalMode(data);
        }
    };

    Self.prototype.__saveNextActionDataModalMode = function (data) {
        var that = this,
            sent_to = data.sent_to || '',
            login = data.login || '',
            next_code_time = data.next_code_time || 0;

        // in modal mode, save values into DOM elements
        that.$next_action_sent_to.text(sent_to);
        that.$next_action_login_input.val(login);
        that.$next_action_code_request_timelimit
            .attr('data-' + that.data_keys.next_action_next_code_time_limit, next_code_time);
    };

    Self.prototype.__saveNextActionDataNotModalMode = function (data) {
        var that = this,
            sent_to = data.sent_to || '',
            login = data.login || '',
            login_type = data.type || 'unknown',
            next_code_time = data.next_code_time || 0,
            key_prefix = that.next_action_data_key_prefix + '-';

        // not in modal mode (if next action is on separate page e.g.), save data into local storage
        sessionStorage.setItem(key_prefix + 'login', login);
        sessionStorage.setItem(key_prefix + 'login-type', login_type);
        sessionStorage.setItem(key_prefix + 'sent-to', sent_to);
        sessionStorage.setItem(key_prefix + 'next-request-timelimit', next_code_time);
    };

    Self.prototype.setSuccessSentToText = function (sent_to) {
        this.$success_sent_to.text(sent_to);
    };

    return Self;
})(jQuery);
